import React from "react";
import styles from "./CalendarSubscription.module.css";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { SendCalendar } from "../../store/auth-store/auth-actions";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../store/auth-store/auth-slice";
import { getTokenInfo } from "../../utils/Guard";

const CalendarSubscription = () => {
  const dispatch = useDispatch();
  const userInfo = getTokenInfo();

  const onSubmitHandler = () => {
    if (userInfo !== undefined && userInfo !== null) {
      dispatch(SendCalendar(userInfo.Email, userInfo.Name));
    }
    else {
      dispatch(userActions.setLoginVisible(true));
    }
  }



  return (
    <div className={styles.CalendarSuscription}>
      <div className={styles.infoContainer}>
        <h1 style={{ fontWeight: "400" }}>Recibe nuestro calendario de capacitaciones</h1>
        <h1 style={{ fontWeight: "600" }}>{new Date().getFullYear()}</h1>
        <div style={{ display: "flex", flexDirection: "column", gap: "1vw" }}>
          {/* <InputText
            className={styles.loginInput}
            id="name"
            placeholder="Nombre"
            onChange={(e) =>
              onChangeHandler("name", e.target.value)
            }
            value={user.name}
          />
          <InputText
            className={styles.loginInput}
            type="email"
            placeholder="Email"
            onChange={(e) =>
              onChangeHandler("email", e.target.value)
            }
            value={user.email}
          /> */}
          <Button onClick={() => onSubmitHandler()} label="Enviar a mi correo" className={styles.sendButton} />
        </div>
      </div>
    </div>
  );
}

export default CalendarSubscription;